import { render } from "./Edit.vue?vue&type=template&id=e33c74d6"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render

export default script